import { MoonIcon, SunIcon } from '@radix-ui/react-icons';
import { useTheme } from '../hooks/useTheme';

export function DarkModeToggle({ onToggle }: { onToggle?: () => void }) {
  const { theme, toggleDarkMode } = useTheme();

  return (
    <div>
      {theme === 'dark' ? (
        <SunIcon
          className="cursor-pointer"
          height={24}
          width={24}
          onClick={() => {
            toggleDarkMode();
            onToggle?.();
          }}
        />
      ) : (
        <MoonIcon
          className="cursor-pointer"
          height={24}
          width={24}
          onClick={() => {
            toggleDarkMode();
            onToggle?.();
          }}
        />
      )}
    </div>
  );
}
